<app-modal-header class="border-b-2 border-theme-500">
  <div class="flex w-full bg-white">
    <div class="flex">
      <svg-icon class="w-10 text-theme-500" src="assets/icons/icon-gestor-avaliacoes.svg" alt="Materiais Didaticos">
      </svg-icon>
      <h1 class="ml-3 hidden text-sm font-semibold leading-tight text-gray-800 md:grid" translate>
        gestor-avaliacoes.cpb
        <br />
        <b class="text-lg text-black" translate>gestor-avaliacoes.prova</b>
      </h1>
    </div>

    <hr app-modal-divider />

    <div class="flex w-full items-center justify-between">
      <div class="mr-5 grid">
        <span class="text-lg font-semibold leading-tight text-gray-800" translate>
          gestor-avaliacoes.cartao-resposta-upload
        </span>
        <div class="grid gap-2 md:flex">
          <div
            class="group/copy flex cursor-pointer"
            app-clipboard
            app-tooltip
            [tooltip]="'geral.copiar' | translate"
            [clipboard]="data?.application?.avaliacao?.code | uppercase"
          >
            <span class="flex uppercase text-gray-500"> # {{ data?.application?.avaliacao?.code }} | </span>
          </div>
          <span class="whitespace-pre-wrap uppercase text-gray-500"> {{ data?.application?.avaliacao?.titulo }} </span>
        </div>
      </div>
    </div>
  </div>
</app-modal-header>

<div app-modal-content class="h-[calc(var(--vh)_*_80)] w-[90vw] !p-0 lg:h-[50rem] lg:w-[80rem]">
  <app-sidenav-group>
    <ng-template app-sidenav-outer>
      <div class="grid gap-2 overflow-auto p-5">
        <div class="flex flex-col gap-2 rounded-lg border border-base-status-info-300 bg-base-status-info-50 px-5 py-2">
          <div class="flex gap-2">
            <svg-icon
              class="flex w-[14px] text-base-status-info-500"
              src="assets/icons/icon-notify-fine.svg"
              alt="icon"
            ></svg-icon>
            <span class="font-semibold" translate> geral.obs </span>
          </div>
          <div class="grid gap-4">
            <div class="flex items-baseline gap-2">
              <svg-icon class="flex h-2 w-2 text-gray-700" src="assets/icons/icon-ellipse.svg"></svg-icon>
              <span>
                Prefira enviar os cartões individualmente em formato <strong>PNG</strong> ou <strong>JPG</strong>.
              </span>
            </div>
            <div class="flex items-baseline gap-2">
              <svg-icon class="flex h-2 w-2 text-gray-700" src="assets/icons/icon-ellipse.svg"></svg-icon>
              <span
                >Você também pode enviar os cartões em formato <strong>PDF</strong>, com no mínimo um arquivo por turma.
              </span>
            </div>
            <div class="flex items-baseline gap-2">
              <svg-icon class="flex h-2 w-2 text-gray-700" src="assets/icons/icon-ellipse.svg"></svg-icon>
              <span>Se o PDF for muito grande, divida em arquivos menores. </span>
            </div>
          </div>
        </div>
        <div class="flex w-full">
          <app-form-field class="w-full">
            <label app-label translate> gestor-avaliacoes.modelo </label>
            <ng-select
              app-select
              [formControl]="modelCtrl"
              [clearable]="false"
              [searchable]="false"
              [items]="printResponseCard"
              bindLabel="name"
              bindValue="id"
              [placeholder]="'gestor-avaliacoes.selecione-modelo' | translate"
            >
              <ng-template ng-label-tmp let-index="index" let-item="item">
                <div class="flex items-center gap-2">
                  <img height="25" width="25" [src]="item.icon" />
                  <span>{{ item.name }}</span>
                </div>
              </ng-template>

              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div class="!flex !items-center !gap-2">
                  <img height="25" width="25" [src]="item.icon" /> <span>{{ item.name }}</span>
                </div>
              </ng-template>
            </ng-select>
          </app-form-field>
        </div>
        <div class="w-full">
          <app-upload-file [componentReset]="resetDropzone$ | async" class="w-full" [config]="config"></app-upload-file>
        </div>
        <div class="flex h-[14vh] w-full flex-col gap-2 overflow-auto overflow-y-auto md:h-[43vh] lg:h-[18rem]">
          <app-card
            *ngFor="let file of files$ | async; let i = index"
            class="flex w-full !flex-row items-center justify-between border p-4"
          >
            <div class="flex items-center gap-2">
              <svg-icon
                class="flex h-8 w-8 cursor-pointer text-gray-500 hover:text-gray-600"
                src="assets/icons/icon-upload-small.svg"
              ></svg-icon>
              <div class="mx-4 flex flex-col items-start whitespace-nowrap">
                <span class="text-sm font-bold md:text-md">{{ file?.fileName }}</span>
              </div>
            </div>
            <button
              app-flat-button
              [disabled]="loading$ | async"
              (click)="removeFile(i)"
              type="button"
              class="bg-base-status-danger"
            >
              <svg-icon class="flex h-5 w-5 text-white" src="assets/icons/icon-trash.svg"></svg-icon>
            </button>
          </app-card>
        </div>
      </div>
    </ng-template>
    <ng-template app-sidenav-end [opened]="true">
      <ng-container class="!px-4 !py-4" *ngIf="uploadHistory$ | async as uploadHistory">
        <div class="flex flex-col gap-2 px-4 py-4">
          <span class="text-lg font-semibold">Histórico de envios</span>
          <ng-container *ngIf="!uploadHistory?.length; else dataTemplate">
            <app-card>
              <div app-card-content class="grid gap-4 !p-3">
                <app-skeleton *ngIf="loadingHistory$ | async; else jumbotron"></app-skeleton>
                <ng-template #jumbotron>
                  <app-jumbotron [showIcon]="false" class="py-2" translate>
                    <svg-icon
                      class="mb-5 w-10 text-gray-300"
                      src="assets/icons/icon-info-rounded.svg"
                      alt="Materiais Didaticos"
                    >
                    </svg-icon>
                    Nenhum envio realizado
                  </app-jumbotron>
                </ng-template>
              </div>
            </app-card>
          </ng-container>
          <ng-template #dataTemplate>
            <div
              class="flex flex-col gap-2 rounded-lg border border-base-status-info-300 bg-base-status-info-50 px-5 py-2"
            >
              <div class="flex gap-2">
                <svg-icon
                  class="flex w-[14px] text-base-status-info-500"
                  src="assets/icons/icon-notify-fine.svg"
                  alt="icon"
                ></svg-icon>
                <span class="font-semibold" translate> geral.obs </span>
              </div>
              <div class="grid gap-4">
                <div class="flex items-baseline gap-2">
                  <svg-icon class="flex h-2 w-2 text-gray-700" src="assets/icons/icon-ellipse.svg"></svg-icon>
                  <span>
                    Se após <strong>5 horas</strong> o processamento do cartão não tiver sido concluído, exclua o
                    arquivo e envie novamente.
                  </span>
                </div>
              </div>
            </div>
            <app-card
              *ngFor="let history of uploadHistory; let i = index"
              class="flex w-full items-center justify-between border p-4"
            >
              <div class="mx-4 flex w-full flex-col items-center gap-2 truncate pb-3">
                <div class="truncate text-sm font-bold md:text-md">{{ history?.nome }}</div>
                <div *ngIf="!!history.user" class="flex items-start text-sm font-light md:text-base">
                  {{ history?.user?.name }} - {{ history?.created_at | date : 'dd/MM/yyyy HH:mm' }}
                </div>
                <div *ngIf="isComplete(history)" class="flex justify-center">
                  <span class="h-fit rounded-full bg-base-status-success-200 px-3 text-base-status-success">
                    Finalizado
                  </span>
                </div>

                <div *ngIf="isPending(history) && !isError(history)" class="flex justify-center">
                  <span class="h-fit rounded-full bg-base-status-warning-200 px-3 text-base-status-warning">
                    Em processamento
                  </span>
                </div>

                <div *ngIf="isError(history)" class="flex justify-center">
                  <span class="h-fit rounded-full bg-base-status-danger-200 px-3 text-base-status-danger">
                    Erro no processamento
                  </span>
                </div>
              </div>

              <div class="flex items-center gap-4">
                <span>Pág. {{ history.tentativas_count || 0 }}/{{ history.page_count }}</span>
                <button app-flat-button (click)="downloadFile(history)" type="button" class="bg-base-status-info">
                  <svg-icon
                    app-tooltip
                    [tooltip]="'geral.download' | translate"
                    class="flex h-5 w-5 text-white"
                    src="assets/icons/icon-download.svg"
                  ></svg-icon>
                </button>
                <button
                  app-flat-button
                  [disabled]="isPending(history) && !isError(history)"
                  (click)="onRemove(history)"
                  type="button"
                  class="bg-base-status-danger"
                >
                  <svg-icon
                    app-tooltip
                    [tooltip]="'gestor-avaliacoes.remover' | translate"
                    class="flex h-5 w-5 text-white"
                    src="assets/icons/icon-trash.svg"
                  ></svg-icon>
                </button>
              </div>
            </app-card>
          </ng-template>
        </div>
      </ng-container>
    </ng-template>
  </app-sidenav-group>
</div>

<div app-modal-footer>
  <button
    [disabled]="(loading$ | async) || (files$ | async | isEmpty)"
    app-flat-button
    type="button"
    class="flex transform items-center justify-center gap-2 bg-theme-500 px-5 py-2 uppercase text-white shadow-md transition duration-300 ease-in-out hover:bg-theme-600 focus:outline-none focus:ring-2 focus:ring-theme-500 focus:ring-opacity-50 disabled:opacity-50"
    (click)="save()"
  >
    <ng-container *ngIf="loading$ | async">
      <div class="flex h-6 w-6 items-center justify-center">
        <app-skeleton class="flex h-5 w-5" baseStyle="bg-theme-500" [showLabel]="false"></app-skeleton>
      </div>
    </ng-container>
    <span translate>gestor-avaliacoes.fazer-upload</span>
  </button>
</div>
